<template v-slot:top>
    <div id="listings_wrapper">

        <v-dialog 
            v-model="deleteConfirm" 
            width="35%"
            elevation="8"
            persistent>
            <v-card>
                <v-card-title class="headline primary darken-1 white--text">
                    <span>Delete Listing Confirmation</span>
                </v-card-title>
        
                <v-card-text style="font-size: .96em">
                    <p class="my-4">Only click the confirm button below if this listing was a mistake, has no buyers associated with it & you want to delete it forever.</p>
                    <p class="my-4">If we want to keep the buyer associations and it's data for report purposes, please hit cancel and change the status to Archived.</p>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn 
                        class="mr-3" 
                        outlined 
                        color="primary darken-1"
                        @click="deleteConfirm = false">
                        Cancel
                    </v-btn>
                    <v-btn 
                        class="white--text" 
                        color="primary darken-1"
                        @click="deleteListing()">
                        Confirm
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <div class="ma-3"> 
            <div class="mt-5 mb-6 d-flex d-block align-center">
                <div class="title font-weight-light">
                    <a @click="goToListings()" class="primary--text text--darken-2">
                        <v-icon color="primary darken-1" class="mt-n1">mdi-menu-left</v-icon> Listings
                    </a>
                </div>
                <v-spacer></v-spacer>
                <!-- <generate-pdf-of-listing
                    v-if="editedIndex > -1"
                    :listingId="editListing.listing_id"
                    :lastUpdatePdf="editListing.pdf_last_gen_date"
                /> -->

                <v-btn
                    v-if="editListing.id"
                    color="accent"
                    outlined
                    hide-details
                    class="mr-12 elevation-1 white--text"
                    @click="deleteConfirm = true">
                    Delete <v-icon class="ml-2 accent--text">mdi-delete</v-icon>
                </v-btn>

                <upload-pdf-of-listing
                    v-if="editListing.id"
                    :listingId="editListing.listing_id"
                    :lastUploadedPdf="editListing.pdf_last_gen_date"
                />

                <v-btn
                    v-if="editListing.id"
                    outlined
                    color="primary darken-1"
                    hide-details
                    class="ml-3 elevation-1"
                    @click="openBuyersDialog()"
                    :disabled="editListing.buyer_ratio == 0 || undefined">
                    Buyers
                </v-btn>
            </div>

            <div class="my-8">
                <Prospectus
                    v-if="readyToLoad"
                    :editListing="editListing"
                    :lists="{
                        states,
                        listing_statuses,
                        listing_stages,
                        listing_types,
                        communication_methods
                    }"
                    :savingListingData="savingListingData"
                    @updateListing="updateListing" 
                />
                <div v-else class="text-center py-12 my-12" style="width: 100%">
                    <v-progress-circular
                        indeterminate 
                        color="error darken-3" 
                        class="my-12 py-12" 
                        size="100" 
                        width="8">
                    </v-progress-circular>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import Cookie from 'js-cookie';
    import appUrls from '../helpers/environment';
    
    import Prospectus from './prospectus-sections/index';
    import UploadPdfOfListing from './partials/uploadProspectusPdf'

    // import GeneratePdfOfListing from './partials/generatePdfOfListing'
    
    export default {
        name: 'ListingDetails',

        components: {
            Prospectus,
            UploadPdfOfListing,
            // GeneratePdfOfListing,
        },
        
        data: () => ({
            pulling_buyers: false,
            listing_types: [],
            listing_stages: [],
            editListing: {},
            listingToggle: false,
            savingListingData: false,
            deleteConfirm: false,
            communication_methods: [],
            states: [],
            listing_statuses: [],
            readyToLoad: false
        }),

        watch: {
            listingToggle () {
                this.getListingDetails()
            },
            
            editListing: {
                handler(obj_values){
                    document.title = `${obj_values.listing_id}: Listing Details`;
                },
                deep: true
            }
        },

        created () {
            this.getLists();
        },
        
        mounted () {
            if ( this.$route.params.lid != 'undefined' ) {               
                this.getListingDetails()
                setTimeout(() => {
                    this.readyToLoad =true
                }, 1000)
            } else {
                this.readyToLoad = true
            }
        },
        
        methods: {
            goToListings: function () {
                this.$router.push({ path: `/listings`});
            },

            triggerUserFeedback: function ( feedback_trigger, feedback_message, feedback_color='light-green' ) {
                this.$feedback.trigger( feedback_trigger, feedback_message, feedback_color );
            },

            openBuyersDialog: async function () {
                let route = this.$router.resolve({ path: `/listing_buyers/${this.$route.params.lid}`});
                window.open(route.href, '_blank');
            },

            deleteListing: async function ( lid ) {
                const delete_rs = await axios.get(`${appUrls.api}/api/admin/delete_listing/${this.editListing.id}`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                })

                this.triggerUserFeedback( true, delete_rs.data.message, !delete_rs.data.outcome ? 'accent' : 'light-green' )
                this.deleteConfirm = false

                if ( delete_rs.data.outcome ) {
                    setTimeout(() => {
                        this.$router.push({ path: `/listings`});
                    }, 3500)
                }
            },
            
            getListingDetails: async function () {
                try {
                    const get_listings = await axios.get(`${appUrls.api}/api/admin/listing/${this.$route.params.lid}`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                    })

                    if ( get_listings.data.outcome ) { 
                        this.editListing = get_listings.data.listing

                        // IMAGE
                        if (this.editListing.custom_image != null ) {
                            this.editListing.image = require(`@/assets/listings/custom/${this.editListing.custom_image}`);
                        } else {
                            this.editListing.image = require(`@/assets/listings/states/${this.editListing.state}.jpg`);
                        }

                        // POST DATE
                        this.editListing.post_date = this.editListing.post_date != null ? this.editListing.post_date.substr(0, 10) : '';
                        // ANTICIPATED CLOSE DATE
                        this.editListing.anticipated_close_date = this.editListing.anticipated_close_date != null ? this.editListing.anticipated_close_date.substr(0, 10) : '';
                        // REVENUE T12 AS OF DATE
                        this.editListing.revenue_t12_asof_date  = this.editListing.revenue_t12_asof_date != null ? this.editListing.revenue_t12_asof_date.substr(0, 10) : '';

                        this.editListing.listing_type = this.editListing.listing_type != null ? parseInt(this.editListing.listing_type) : 0;
                        this.editListing.status       = this.editListing.status != null ? parseInt(this.editListing.status) : 0;
                        this.editListing.stage        = this.editListing.stage != null ? parseInt(this.editListing.stage) : 0;

                        // AUM :: AUA 

                        // STATUS NAME
                        if ( this.editListing.status != 0 ) {
                            let statusObj = this.listing_statuses.find(obj => parseInt(obj.value) === this.editListing.status);
                            this.editListing.status_name = statusObj.text;
                        } else {
                            this.editListing.status_name = '<span style="color:#F04881">Not Defined</span>';
                        }

                        // STAGE NAME
                        if ( this.editListing.stage != 0 ) {
                            let stageObj = this.listing_stages.find(obj => parseInt(obj.value) === this.editListing.stage);
                            this.editListing.stage_name = stageObj.text;
                        } else {
                            this.editListing.stage_name = '<span style="color:#F04881">Not Defined</span>';
                        }

                        // TYPE NAME
                        if ( this.editListing.listing_type != 0 ) {
                            let typeObj = this.listing_types.find(obj => parseInt(obj.value) === this.editListing.listing_type);
                            this.editListing.type_name = typeObj.text;
                        } else {
                            this.editListing.type_name = '<span style="color:#F04881">Not Defined</span>';
                        }

                        // BUYERS OF TOTAL BUYERS
                        if ( this.editListing.total_buyers != 0 || undefined ) {
                            this.editListing.buyer_ratio = this.editListing.buyer_count+' of '+this.editListing.total_buyers;
                        } else {
                            this.editListing.buyer_ratio = 0;
                        }
                    } else {
                        this.$feedback.error( 'There seems to be a problem pulling the listing. Run, tell Cliff!' );
                    }
                } catch ( error ) {
                    console.log(error);
                    this.$feedback.error( 'There seems to be a problem pulling the listing. Run, tell Cliff!' );
                }
            },

            updateListing: function (listingData) {
                this.editListing = listingData;
                this.saveData();
            },

            saveData: async function () {
                try {
                    const save_listing = await axios.post(`${appUrls.api}/api/admin/save_listing`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        save: this.editListing
                    })
                
                    if ( save_listing.data.outcome ) {
                        this.$feedback.success( save_listing.data.message );

                        this.savingListingData = !this.savingListingData

                        if ( save_listing.data.action == 'insert' ) {
                            this.$router.push({ path: `/listing_details/${save_listing.data.listing.id}` });
                            this.listingToggle = !this.listingToggle
                        } else {
                            this.getListingDetails()
                        }
                    } else {
                        this.$feedback.error( save_listing.data.message );
                    }
                } catch (error) {
                    console.log(error);
                    this.$feedback.error( 'There was a problem updating this prospectus!' );
                }
            },

            getLists: async function () {
                try {
                    let optionsLists = [ 
                        {'name': 'listing_types', 'type': 'int'}, 
                        {'name': 'listing_stages', 'type': 'int'},
                        {'name': 'listing_statuses', 'type': 'int'},
                        {'name': 'states', 'type': 'txt'},
                        {'name': 'communication_methods', 'type': 'txt'}
                    ];

                    const get_lists = await axios.post(`${appUrls.api}/api/lists`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        list_options: optionsLists
                    })
  
                    if ( get_lists.data.outcome ) {
                        let arrLists = get_lists.data.lists;                        
                        // SET PROPERTIES WITH THIER APPROPRIATE LIST
                        for (let l in arrLists) {
                            if (arrLists[l].name == 'states') this.states = arrLists[l].list
                            if (arrLists[l].name == 'listing_stages') this.listing_stages = arrLists[l].list
                            if (arrLists[l].name == 'listing_types') this.listing_types = arrLists[l].list
                            if (arrLists[l].name == 'listing_statuses') this.listing_statuses = arrLists[l].list
                            if (arrLists[l].name == 'communication_methods') this.communication_methods = arrLists[l].list
                        }
                    }
                } catch (error) {
                    console.log(error);
                }
            }
        }
    }
</script>

<style scoped>
    #listings_wrapper {
        width: 100%;
        margin: 0 auto;
        padding: 3rem 0 0 0;
        display: flex;
        flex-direction: column;
        height: 100vh; 
    }
</style>


// WEBPACK FOOTER //
// src/components/ListingDetails.vue